<template>
  <CustomPage title="会场访问记录" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="flex justify-between text-xs mx-3 mb-3"
        style="color: #666666"
      >
        <Popover
          class="mr-3"
          :offset="[30, 0]"
          v-model="showPopover"
          trigger="click"
          :actions="[{ text: '今日' }, { text: '本周' }, { text: '本月' }]"
          @select="onSelect"
        >
          <template #reference>
            <div class="font-semibold">
              {{ selectedAction
              }}<Icon class="transform rotate-90" name="play" color="#E82035" />
            </div>
          </template>
        </Popover>
        <div class="flex w-1/3 justify-between">
          <div @click="sort = true" :class="sort ? 'active-sort' : ''">
            按人数
          </div>
          <div @click="sort = false" :class="sort ? '' : 'active-sort'">
            按订单数
          </div>
        </div>
      </div>
      <div>
        <div
          v-for="item in data"
          :key="item.signBrandId"
          class="
            flex
            items-center
            van-hairline--bottom
            p-3
            lightshadow
            m-3
            rounded
          "
        >
          <!-- @click="
            $router.push({
              name: 'StorePlaceDataDetail',
              params: { id: i, brand: '耐克' },
            })
          " -->
          <div class="mr-2" style="height: 40px; width: 40px">
            <img class="w-full h-full rounded" :src="item.brandLogo" alt="" />
          </div>
          <div class="flex-grow">
            <div class="font-semibold">{{ item.brandName }}</div>
            <div class="text-xs flex items-center">
              <!-- <div class="mr-2" style="height: 16px; width: 16px">
                <img
                  class="w-full h-full rounded-full"
                  src="https://img01.yzcdn.cn/vant/cat.jpeg"
                  alt=""
                />
              </div> -->
              <div class="text-gray">
                <!-- 等 -->
                <span class="text-red">{{ item.visitNum }}</span
                >人访问 <span class="text-red">{{ item.orderNum }}</span
                >笔成交订单
              </div>
            </div>
          </div>
          <!-- <Icon name="arrow" /> -->
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import { Popover, Icon } from "vant";
import { getBrandAccessLog } from "../webApi";
export default {
  components: {
    CustomPage,
    CustomView,
    Popover,
    Icon,
  },
  created() {
    this.getData();
  },
  data() {
    return {
      showPopover: false,
      sort: true,
      selectedAction: "今日",
      data: [],
    };
  },
  methods: {
    getData() {
      let params = {
        dateType: null,
        bool: this.sort,
      };
      switch (this.selectedAction) {
        case "今日":
          params.dateType = "today";
          break;

        case "本周":
          params.dateType = "thisWeek";

          break;
        case "本月":
          params.dateType = "thisMonth";

          break;

        default:
          break;
      }
      getBrandAccessLog(params).then(({ data }) => {
        this.data = data;
      });
    },

    onSelect(action) {
      this.selectedAction = action.text;
      this.getData();
    },
  },

  watch: {
    sort() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}

.active-sort {
  color: #e82035;
}
</style>